















































import { addItemsToListIfAreNotAdded, booleanFormatter, CANT_SEE_SECTION_MSG, formatList, ID, PRIVILEGE_KEYS, PRIVILEGE_TYPES, removeItemsFromList } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import Input from '../../core/components/Input.vue';
import {
    Combobox,
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment, { invalid } from 'moment';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, AvailableVehiclesList, Vehicle, RadioOptions, RadioOption } from '../../core/models';
import { ReportsServices } from '../api/ReportsServices';
import { CompaniesService } from '../../settings/api/CompaniesService';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleTable,
        Input,
        TableArrows
    }
})
export default class VehiclesForSuscription extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default(){return []}}) selectedCompanies: Array<Company>;
    @Prop({default: ''}) vehicleRadioSelected: string;
    patchVehicles: Array<AvailableVehiclesList> = [];
    availableVehicles: Array<AvailableVehiclesList> = [];
    cantSeeVehicles: string = CANT_SEE_SECTION_MSG;
    sortBy: Array<string> = ['description'];
    sortDesc: Array<boolean> = [false];
    noDataText: string = '';
    noAvailableVehiclesMsg: string = 'No hay vehículos para las empresas seleccionadas';
    noSelectedVehiclesMsg: string = 'No hay vehículos seleccionados';
    radioValue: string = 'radio-available';
    selectedAvailableVehicles: Array<object> = [];
    selectedVehicles: Array<object> = [];
    addedVehicles: Array<AvailableVehiclesList> = [];
    searchAvailableVehicles: string = '';
    searchSelectedVehicles: string = '';
    loadingAvailableVehicles: boolean = false;
    isPatch: boolean = false;
    needToPreselectVehicles: boolean = false;
    tableSyncOptions: any = {
        page: 1
    }
    currentPage: number = 1;
    counter: number = 0;
    headers: Array<object> = [
            {
                text: 'Vin',
                value: 'vin',
                sortable: true,
                width: '205px'
            },
            {
                text: 'Descripción',
                value: 'description',
                sortable: true
            },
            {
                text: 'Empresas',
                value: 'company',
                sortable: true,
            }
    ];
    updateTableOptions(options){
       this.tableSyncOptions.page = options.page;
    }


    addedFormatter(value){
        return booleanFormatter(value)
    }

    get refTableAvailableVehicles(): HTMLFormElement {
        return this.$refs.tableAvailableVehicles as HTMLFormElement;
    }
    
    updateSearchAvailableVehicles(rows){
        this.searchAvailableVehicles = rows;
    }
    updateSelectedAvailableVehicles(rows){
        this.updateSearchAvailableVehicles('');
        this.selectedAvailableVehicles = rows;
    }
    updateSelectedVehicles(rows){
        this.selectedVehicles = rows;
    }

    removeVehiclesFromRemovedCompany(removedCompany: string){
        /* 
            Al quitar una empresa tengo que quitar los vehiculos
            que vehicle.companies no incluya el que quite 
        */
       let invalidVehicles = this.addedVehicles.filter(function(veh:AvailableVehiclesList){
        return veh.company.includes(removedCompany)
       })
    }


    updateVehiclesToPreselect(vehicles: Array<AvailableVehiclesList>){
         this.isPatch = true;
         this.needToPreselectVehicles = true;
         this.patchVehicles = vehicles;
    }

    @Watch('radioValue')
    observableRadioValue(value){
        if(value === 'radio-selected'){
            this.noDataText = this.noSelectedVehiclesMsg;
            this.tableSyncOptions.page = 1
        }else{
            this.noDataText = this.noAvailableVehiclesMsg
        }
    }

    preselectVehiclesForPatch(){
        this.radioValue = 'radio-selected';
        this.updateSelectedItemsInTable(this.patchVehicles);
        this.checkHasToChangeRadio();
        this.needToPreselectVehicles = false;
    }

     checkHasToChangeRadio(){
        /* En el Patch selecciono el tipo de radio button */
        if(this.patchVehicles.length == this.availableVehicles.length){
            //Si el n° de vehiculos del patch es igual al n° del listado
            //marco "Todos"
            this.updateRadioOption(RadioOptions.all_vehicles)
        }else{
            //Sino marco Solo algunos
            this.updateRadioOption(RadioOptions.some_vehicles)
        }
     }

     @Emit()
     updateRadioOption(radioId: RadioOption){}

    @Watch('selectedCompanies')
    observableSelectedCompanies(companies: Array<Company>){
        this.getAvailableVehicles(companies);
        if(companies.length == 0){
            this.clearAddedVehicles();
        }
    }

    updateSelectedItemsInTable(items){
        this.refTableAvailableVehicles.updateSelectedItems(items)
    }

    selectAllAvailableVehicles(){
        this.updateSelectedItemsInTable(this.availableVehicles);
    }

    uncheckAllAvailableVehicles(){
        this.updateSelectedItemsInTable([]);
    }

    clearAddedVehicles(){
        this.uncheckAllAvailableVehicles();
    }

    get userCanSeeVehicles(){
        return this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.READ)
    }

    get getTableVehicles(){
        if(this.radioValue === 'radio-selected'){
            return this.selectedAvailableVehicles
        }else{
            return this.availableVehicles
        }
    }

    setAvailableVehicles(items){
        let self = this;
        let availableVehiclesList = items.map(function(veh){
            return {
                ...veh,
                company: veh.company.map(company => company.name)
            }
        });
        if(this.vehicleRadioSelected === RadioOptions.all_vehicles){
            this.updateSelectedItemsInTable(availableVehiclesList)
        }
        this.availableVehicles = availableVehiclesList;
    }

    @Emit()
    updateVehiclesForSubscription(vehicles: Array<object>){}

     getAvailableVehicles(selectedCompanies: Array<Company>){
        /* Obtengo la lista de vehiculos disponibles segun las empresas seleccionadas */
        let companyIds: ID[] = selectedCompanies.map(company => company.id);
        
        this.availableVehicles = [];
        if(companyIds.length !== 0){
            this.counter++;
            this.loadingAvailableVehicles = true;
            CompaniesService.getVehiclesForCompanies(
                companyIds
            ).then((res) => {
                this.setAvailableVehicles(res);
                if(this.counter == 1 && !this.isPatch){
                    this.selectAllAvailableVehicles();
                }
                if(this.needToPreselectVehicles){
                    this.preselectVehiclesForPatch();
                }
                this.loadingAvailableVehicles = false;
            }).catch((err) => {
                this.loadingAvailableVehicles = false;
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'No se pudieron obtener los vehiculos'
                })
            })  
        }
    }
}
